import { Component, Output, EventEmitter, Input, OnChanges, ChangeDetectorRef } from "@angular/core"
import { FormControl } from "@angular/forms"
import { Observable, Subscription } from "rxjs"
import { map, startWith } from "rxjs/operators"

@Component({
	selector: "app-pop-autocomplete",
	templateUrl: "./pop-autocomplete.component.html",
	styleUrls: ["./pop-autocomplete.component.scss"]
})
export class PopAutocompleteComponent implements OnChanges {
	@Output() placeSelected = new EventEmitter<any>()
	@Input() label: string
	@Input() index: string | number
	@Input() popList: any[] = []
	@Input() placeholder: string

	popControl = new FormControl()
	popsOptions: Observable<string[]>

	itemHeight = 48
	listHeight: number | null = null
	listHeightSubscribe: Subscription

	constructor(private cdr: ChangeDetectorRef) {}

	ngOnInit() {
		this.listHeightSubscribe = this.popsOptions.subscribe(res => {
			this.listHeight = res.length * this.itemHeight
		})
	}

	ngOnDestroy() {
		this.listHeightSubscribe?.unsubscribe()
	}

	ngOnChanges(changes) {
		this.popControl.setValue(this.label || "")
		this.label = changes.label?.currentValue || ""

		this._initAutoComplete()
		this.cdr.detectChanges()
	}

	emitPop(e) {
		this.popControl.setValue(e.nome || "")
		this.placeSelected.emit({ point: e, isValid: true })
	}

	private _filter(value: string, list): string[] {
		const filterValue = typeof value === "string" ? value.toLowerCase() : ""
		return list.filter(option => option.nome.toLowerCase().includes(filterValue))
	}

	private _initAutoComplete(pops?) {
		const list = pops || this.popList

		if (list && list.length) {
			this.popsOptions = this.popControl.valueChanges.pipe(
				startWith(""),
				map(value => this._filter(value, list))
			)
		}
	}

	trackByName(index, item) {
		return item.name
	}
}
